module.exports = __webpack_public_path__ + "static/sidelogo-6c633ef1e009ba946be6623888f5c093.svg";